import type { SheetGeometry } from "building-types/views/sheetGeometryTypes";
import { sheetPolylineGeometryNew } from "building-types/views/sheetGeometryTypes";
import type { PlanGenerationContext } from "doc/plans/planGeometrySource";
import type { PolyLine2 } from "geom/polyLine2Types";
import { columnsOnLevel } from "lib/house/building/columnsOnLevel";
import { getReportingUnitRoomIds, hostRoomsInReportingUnit } from "../reportingUnitRooms";

export function makeSheetGeometryFromGeneratedColumns({
  building,
  levelId,
  selectedReportingUnitLabelId,
}: PlanGenerationContext): SheetGeometry[] {
  const result: SheetGeometry[] = [];
  const { columns, levels, rooms } = building;
  const reportingUnitRoomIds = getReportingUnitRoomIds(building, selectedReportingUnitLabelId);

  const levelColumns = columnsOnLevel(levelId, columns);

  const columnEdges: PolyLine2[] = [];
  for (const columnIdx of Object.keys(levelColumns)) {
    const column = levelColumns[columnIdx];
    if (!hostRoomsInReportingUnit(reportingUnitRoomIds, [rooms[column.roomId]])) {
      continue;
    }
    columnEdges.push(...column.planProfiles);
  }

  //column edges
  result.push(
    sheetPolylineGeometryNew({
      handle: levels[levelId].handle,
      paths: columnEdges,
    }),
  );

  return result;
}
